// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --header-bg: var(--card-bg);
  --header-border: var(--border);
  --header-ink: var(--text-primary);
  --header-accent: var(--primary);
  --header-toggle-line: var(--text-primary);
  --header-dropdown-hover: var(--hover);
}

/* =========================================================
   SITE HEADER — used on every page (marketing + dashboard).
   Same layout/typography as the original marketing header;
   colors now flip with the app's light/dark mode toggle.
   ========================================================= */
.epw-site-header {
  position: sticky;
  top: 0;
  z-index: 1200;
  height: var(--header-height);
  background: var(--header-bg);
  border-bottom: 1px solid var(--header-border);
  display: grid;
  grid-template-columns: 150px 1fr auto;
  align-items: center;
  padding: 0 26px 0 8px;
  font-family: "Arial Narrow", "Roboto Condensed", "Helvetica Neue", Arial, sans-serif;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.epw-site-logo {
  display: flex;
  align-items: center;
  width: 96px;
  height: 74px;
  text-decoration: none;
}
.epw-site-logo img {
  display: block;
  width: 86px;
  height: auto;
  max-height: 72px;
  object-fit: contain;
}

.epw-main-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 34px;
  min-width: 0;
}
.epw-main-nav a {
  color: var(--header-ink);
  text-decoration: none;
  font-weight: 800;
  font-stretch: condensed;
  font-size: 20px;
  line-height: 1;
  white-space: nowrap;
  padding: 27px 0 20px;
  border-bottom: 3px solid transparent;
}
.epw-main-nav a:hover,
.epw-main-nav a:focus-visible {
  color: var(--header-accent);
  outline: none;
}
.epw-main-nav a[aria-current="page"] {
  color: var(--header-accent);
  border-bottom-color: var(--header-accent);
}

.epw-profile {
  display: flex;
  align-items: center;
  gap: 12px;
}

.epw-profile-link {
  display: flex;
  align-items: center;
  gap: 13px;
  color: var(--header-ink);
  text-decoration: none;
  font-weight: 800;
  font-stretch: condensed;
  font-size: 20px;
  line-height: 1;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
}
.epw-profile-link:hover,
.epw-profile-link:focus-visible {
  color: var(--header-accent);
  outline: none;
}

.epw-profile-icon {
  width: 34px;
  height: 34px;
  border: 2px solid currentColor;
  border-radius: 50%;
  position: relative;
  flex: none;
}
.epw-profile-icon:before {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  border: 1.8px solid currentColor;
  border-radius: 50%;
  left: 50%;
  top: 6px;
  transform: translateX(-50%);
}
.epw-profile-icon:after {
  content: "";
  position: absolute;
  width: 18px;
  height: 9px;
  border: 1.8px solid currentColor;
  border-radius: 12px 12px 0 0;
  border-bottom: 0;
  left: 50%;
  bottom: 5px;
  transform: translateX(-50%);
}

.epw-nav-toggle {
  display: none;
  border: 0;
  background: var(--header-bg);
  width: 44px;
  height: 44px;
  padding: 8px;
  cursor: pointer;
}
.epw-nav-toggle span {
  display: block;
  height: 2px;
  background: var(--header-toggle-line);
  margin: 6px 0;
}

@media (max-width: 1150px) {
  .epw-main-nav { gap: 20px; }
  .epw-main-nav a,
  .epw-profile-link { font-size: 17px; }
}

@media (max-width: 900px) {
  .epw-site-header {
    grid-template-columns: auto 1fr auto;
    padding-right: 14px;
  }
  .epw-nav-toggle { display: block; justify-self: end; }
  .epw-profile { margin-left: 10px; }
  .epw-main-nav {
    position: absolute;
    left: 0;
    right: 0;
    top: var(--header-height);
    display: none;
    background: var(--header-bg);
    border-top: 1px solid var(--header-border);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
    padding: 8px 20px 18px;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }
  .epw-main-nav.is-open { display: flex; }
  .epw-main-nav a {
    padding: 14px 4px;
    border-bottom: 1px solid var(--header-border);
    font-size: 18px;
  }
  .epw-main-nav a[aria-current="page"] {
    border-bottom-color: var(--header-border);
    border-left: 3px solid var(--header-accent);
    padding-left: 10px;
  }
  .epw-profile-link { font-size: 0; padding: 0; }
}

/* =========================================================
   ACCOUNT MENU — signed-in state of the profile slot. Same
   look as the signed-out "Profile / Login" link, just with a
   dropdown underneath instead of navigating straight to /login.
   ========================================================= */
.epw-account {
  position: relative;
}

.epw-account-btn {
  font-family: inherit;
}

.epw-account-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 170px;
  background: var(--header-bg);
  border: 1px solid var(--header-border);
  border-radius: 10px;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 1300;
}

.epw-account-dropdown-item {
  width: 100%;
  display: block;
  padding: 12px 16px;
  background: transparent;
  border: none;
  text-align: left;
  font-family: "Arial Narrow", "Roboto Condensed", "Helvetica Neue", Arial, sans-serif;
  font-weight: 700;
  font-stretch: condensed;
  font-size: 16px;
  color: var(--header-ink);
  cursor: pointer;
}
.epw-account-dropdown-item:hover {
  color: var(--header-accent);
  background: var(--header-dropdown-hover);
}

/* =========================================================
   HARMONIZED HERO STYLE
   Every marketing page's hero uses the same brand-red gradient so the
   pages read as one product. Dark mode gets a deeper version of the
   same red instead of the light-mode gradient, so it doesn't wash out
   against the rest of the dark UI.
   ========================================================= */
.epw-who-page .epw-hero,
.epw-serve-page .epw-hero,
.epw-coverage-page .epw-coverage-hero,
.epw-contact-page .epw-hero,
.epw-disclaimer-page .epw-disclaimer-hero,
.epw-faq-page .epw-faq-hero,
.epw-about-page .epw-about-hero {
  background: linear-gradient(135deg, rgba(200, 16, 46, 0.97), rgba(125, 10, 31, 0.97)) !important;
  color: #ffffff !important;
  border-bottom: 0 !important;
}

[data-theme="dark"] .epw-who-page .epw-hero,
[data-theme="dark"] .epw-serve-page .epw-hero,
[data-theme="dark"] .epw-coverage-page .epw-coverage-hero,
[data-theme="dark"] .epw-contact-page .epw-hero,
[data-theme="dark"] .epw-disclaimer-page .epw-disclaimer-hero,
[data-theme="dark"] .epw-faq-page .epw-faq-hero,
[data-theme="dark"] .epw-about-page .epw-about-hero {
  background: linear-gradient(135deg, rgba(142, 9, 28, 0.97), rgba(60, 5, 14, 0.97)) !important;
}

.epw-who-page .epw-hero h1,
.epw-serve-page .epw-hero h1,
.epw-coverage-page .epw-coverage-hero h1,
.epw-contact-page .epw-hero h1,
.epw-disclaimer-page .epw-disclaimer-hero h1,
.epw-faq-page .epw-faq-hero h1,
.epw-about-page .epw-about-hero h1 {
  color: #ffffff !important;
}

.epw-who-page .epw-hero > .epw-wrap > p:not(.epw-eyebrow),
.epw-serve-page .epw-hero > .epw-wrap > p:not(.epw-eyebrow),
.epw-contact-page .epw-hero > .epw-wrap > p:not(.epw-eyebrow),
.epw-disclaimer-page .epw-disclaimer-hero > .epw-wrap > p:not(.epw-eyebrow),
.epw-coverage-page .epw-coverage-hero .epw-hero-grid > div:first-child > p:not(.epw-eyebrow),
.epw-faq-page .epw-faq-hero-inner > p:not(.epw-eyebrow),
.epw-about-page .epw-about-hero > .epw-wrap > p:not(.epw-eyebrow) {
  color: rgba(255, 255, 255, 0.94) !important;
}

.epw-who-page .epw-hero .epw-eyebrow,
.epw-serve-page .epw-hero .epw-eyebrow,
.epw-coverage-page .epw-coverage-hero .epw-eyebrow,
.epw-contact-page .epw-hero .epw-eyebrow,
.epw-disclaimer-page .epw-disclaimer-hero .epw-eyebrow,
.epw-faq-page .epw-faq-hero .epw-eyebrow,
.epw-about-page .epw-about-hero .epw-eyebrow {
  color: #ffffff !important;
  opacity: 0.9;
}

.epw-coverage-page .epw-coverage-hero .epw-globe {
  border-color: rgba(255, 255, 255, 0.38) !important;
  background:
    linear-gradient(90deg, transparent 49.5%, rgba(255, 255, 255, 0.20) 50%, transparent 50.5%),
    linear-gradient(0deg, transparent 49.5%, rgba(255, 255, 255, 0.20) 50%, transparent 50.5%),
    radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.07) 70%, rgba(255, 255, 255, 0.02) 100%) !important;
  box-shadow: 0 12px 32px rgba(54, 0, 10, 0.20) !important;
}
.epw-coverage-page .epw-coverage-hero .epw-globe::before,
.epw-coverage-page .epw-coverage-hero .epw-globe::after {
  border-color: rgba(255, 255, 255, 0.20) !important;
}
.epw-coverage-page .epw-coverage-hero .epw-region-dot span {
  color: #172033 !important;
  background: rgba(255, 255, 255, 0.96) !important;
  border-color: rgba(255, 255, 255, 0.95) !important;
}

.epw-who-page .epw-hero,
.epw-serve-page .epw-hero,
.epw-coverage-page .epw-coverage-hero,
.epw-contact-page .epw-hero,
.epw-disclaimer-page .epw-disclaimer-hero {
  padding-top: 82px !important;
  padding-bottom: 76px !important;
}

@media (max-width: 620px) {
  .epw-who-page .epw-hero,
  .epw-serve-page .epw-hero,
  .epw-coverage-page .epw-coverage-hero,
  .epw-contact-page .epw-hero,
  .epw-disclaimer-page .epw-disclaimer-hero {
    padding-top: 58px !important;
    padding-bottom: 54px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TopMenu.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,iCAAiC;EACjC,+BAA+B;EAC/B,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;;;;8DAI8D;AAC9D;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,4BAA4B;EAC5B,4BAA4B;EAC5B,6CAA6C;EAC7C,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,qBAAqB;EACrB,oFAAoF;EACpF,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;AACtC;AACA;;EAEE,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;AACA;;EAEE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,gBAAgB,SAAS,EAAE;EAC3B;sBACoB,eAAe,EAAE;AACvC;;AAEA;EACE;IACE,oCAAoC;IACpC,mBAAmB;EACrB;EACA,kBAAkB,cAAc,EAAE,iBAAiB,EAAE;EACrD,eAAe,iBAAiB,EAAE;EAClC;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,aAAa;IACb,4BAA4B;IAC5B,0CAA0C;IAC1C,2CAA2C;IAC3C,sBAAsB;IACtB,sBAAsB;IACtB,oBAAoB;IACpB,MAAM;EACR;EACA,wBAAwB,aAAa,EAAE;EACvC;IACE,iBAAiB;IACjB,6CAA6C;IAC7C,eAAe;EACjB;EACA;IACE,yCAAyC;IACzC,2CAA2C;IAC3C,kBAAkB;EACpB;EACA,oBAAoB,YAAY,EAAE,UAAU,EAAE;AAChD;;AAEA;;;;8DAI8D;AAC9D;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,oFAAoF;EACpF,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;;;;;;8DAM8D;AAC9D;;;;;;;EAOE,gGAAgG;EAChG,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;;;;;;EAOE,6FAA6F;AAC/F;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,2CAA2C;AAC7C;;AAEA;;;;;;;EAOE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD;;;8IAG4I;EAC5I,wDAAwD;AAC1D;AACA;;EAEE,kDAAkD;AACpD;AACA;EACE,yBAAyB;EACzB,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;;;;;EAKE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE;;;;;IAKE,4BAA4B;IAC5B,+BAA+B;EACjC;AACF","sourcesContent":[":root {\n  --header-bg: var(--card-bg);\n  --header-border: var(--border);\n  --header-ink: var(--text-primary);\n  --header-accent: var(--primary);\n  --header-toggle-line: var(--text-primary);\n  --header-dropdown-hover: var(--hover);\n}\n\n/* =========================================================\n   SITE HEADER — used on every page (marketing + dashboard).\n   Same layout/typography as the original marketing header;\n   colors now flip with the app's light/dark mode toggle.\n   ========================================================= */\n.epw-site-header {\n  position: sticky;\n  top: 0;\n  z-index: 1200;\n  height: var(--header-height);\n  background: var(--header-bg);\n  border-bottom: 1px solid var(--header-border);\n  display: grid;\n  grid-template-columns: 150px 1fr auto;\n  align-items: center;\n  padding: 0 26px 0 8px;\n  font-family: \"Arial Narrow\", \"Roboto Condensed\", \"Helvetica Neue\", Arial, sans-serif;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.epw-site-logo {\n  display: flex;\n  align-items: center;\n  width: 96px;\n  height: 74px;\n  text-decoration: none;\n}\n.epw-site-logo img {\n  display: block;\n  width: 86px;\n  height: auto;\n  max-height: 72px;\n  object-fit: contain;\n}\n\n.epw-main-nav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 34px;\n  min-width: 0;\n}\n.epw-main-nav a {\n  color: var(--header-ink);\n  text-decoration: none;\n  font-weight: 800;\n  font-stretch: condensed;\n  font-size: 20px;\n  line-height: 1;\n  white-space: nowrap;\n  padding: 27px 0 20px;\n  border-bottom: 3px solid transparent;\n}\n.epw-main-nav a:hover,\n.epw-main-nav a:focus-visible {\n  color: var(--header-accent);\n  outline: none;\n}\n.epw-main-nav a[aria-current=\"page\"] {\n  color: var(--header-accent);\n  border-bottom-color: var(--header-accent);\n}\n\n.epw-profile {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.epw-profile-link {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  color: var(--header-ink);\n  text-decoration: none;\n  font-weight: 800;\n  font-stretch: condensed;\n  font-size: 20px;\n  line-height: 1;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-family: inherit;\n}\n.epw-profile-link:hover,\n.epw-profile-link:focus-visible {\n  color: var(--header-accent);\n  outline: none;\n}\n\n.epw-profile-icon {\n  width: 34px;\n  height: 34px;\n  border: 2px solid currentColor;\n  border-radius: 50%;\n  position: relative;\n  flex: none;\n}\n.epw-profile-icon:before {\n  content: \"\";\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  border: 1.8px solid currentColor;\n  border-radius: 50%;\n  left: 50%;\n  top: 6px;\n  transform: translateX(-50%);\n}\n.epw-profile-icon:after {\n  content: \"\";\n  position: absolute;\n  width: 18px;\n  height: 9px;\n  border: 1.8px solid currentColor;\n  border-radius: 12px 12px 0 0;\n  border-bottom: 0;\n  left: 50%;\n  bottom: 5px;\n  transform: translateX(-50%);\n}\n\n.epw-nav-toggle {\n  display: none;\n  border: 0;\n  background: var(--header-bg);\n  width: 44px;\n  height: 44px;\n  padding: 8px;\n  cursor: pointer;\n}\n.epw-nav-toggle span {\n  display: block;\n  height: 2px;\n  background: var(--header-toggle-line);\n  margin: 6px 0;\n}\n\n@media (max-width: 1150px) {\n  .epw-main-nav { gap: 20px; }\n  .epw-main-nav a,\n  .epw-profile-link { font-size: 17px; }\n}\n\n@media (max-width: 900px) {\n  .epw-site-header {\n    grid-template-columns: auto 1fr auto;\n    padding-right: 14px;\n  }\n  .epw-nav-toggle { display: block; justify-self: end; }\n  .epw-profile { margin-left: 10px; }\n  .epw-main-nav {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: var(--header-height);\n    display: none;\n    background: var(--header-bg);\n    border-top: 1px solid var(--header-border);\n    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);\n    padding: 8px 20px 18px;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0;\n  }\n  .epw-main-nav.is-open { display: flex; }\n  .epw-main-nav a {\n    padding: 14px 4px;\n    border-bottom: 1px solid var(--header-border);\n    font-size: 18px;\n  }\n  .epw-main-nav a[aria-current=\"page\"] {\n    border-bottom-color: var(--header-border);\n    border-left: 3px solid var(--header-accent);\n    padding-left: 10px;\n  }\n  .epw-profile-link { font-size: 0; padding: 0; }\n}\n\n/* =========================================================\n   ACCOUNT MENU — signed-in state of the profile slot. Same\n   look as the signed-out \"Profile / Login\" link, just with a\n   dropdown underneath instead of navigating straight to /login.\n   ========================================================= */\n.epw-account {\n  position: relative;\n}\n\n.epw-account-btn {\n  font-family: inherit;\n}\n\n.epw-account-dropdown {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: 0;\n  min-width: 170px;\n  background: var(--header-bg);\n  border: 1px solid var(--header-border);\n  border-radius: 10px;\n  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  z-index: 1300;\n}\n\n.epw-account-dropdown-item {\n  width: 100%;\n  display: block;\n  padding: 12px 16px;\n  background: transparent;\n  border: none;\n  text-align: left;\n  font-family: \"Arial Narrow\", \"Roboto Condensed\", \"Helvetica Neue\", Arial, sans-serif;\n  font-weight: 700;\n  font-stretch: condensed;\n  font-size: 16px;\n  color: var(--header-ink);\n  cursor: pointer;\n}\n.epw-account-dropdown-item:hover {\n  color: var(--header-accent);\n  background: var(--header-dropdown-hover);\n}\n\n/* =========================================================\n   HARMONIZED HERO STYLE\n   Every marketing page's hero uses the same brand-red gradient so the\n   pages read as one product. Dark mode gets a deeper version of the\n   same red instead of the light-mode gradient, so it doesn't wash out\n   against the rest of the dark UI.\n   ========================================================= */\n.epw-who-page .epw-hero,\n.epw-serve-page .epw-hero,\n.epw-coverage-page .epw-coverage-hero,\n.epw-contact-page .epw-hero,\n.epw-disclaimer-page .epw-disclaimer-hero,\n.epw-faq-page .epw-faq-hero,\n.epw-about-page .epw-about-hero {\n  background: linear-gradient(135deg, rgba(200, 16, 46, 0.97), rgba(125, 10, 31, 0.97)) !important;\n  color: #ffffff !important;\n  border-bottom: 0 !important;\n}\n\n[data-theme=\"dark\"] .epw-who-page .epw-hero,\n[data-theme=\"dark\"] .epw-serve-page .epw-hero,\n[data-theme=\"dark\"] .epw-coverage-page .epw-coverage-hero,\n[data-theme=\"dark\"] .epw-contact-page .epw-hero,\n[data-theme=\"dark\"] .epw-disclaimer-page .epw-disclaimer-hero,\n[data-theme=\"dark\"] .epw-faq-page .epw-faq-hero,\n[data-theme=\"dark\"] .epw-about-page .epw-about-hero {\n  background: linear-gradient(135deg, rgba(142, 9, 28, 0.97), rgba(60, 5, 14, 0.97)) !important;\n}\n\n.epw-who-page .epw-hero h1,\n.epw-serve-page .epw-hero h1,\n.epw-coverage-page .epw-coverage-hero h1,\n.epw-contact-page .epw-hero h1,\n.epw-disclaimer-page .epw-disclaimer-hero h1,\n.epw-faq-page .epw-faq-hero h1,\n.epw-about-page .epw-about-hero h1 {\n  color: #ffffff !important;\n}\n\n.epw-who-page .epw-hero > .epw-wrap > p:not(.epw-eyebrow),\n.epw-serve-page .epw-hero > .epw-wrap > p:not(.epw-eyebrow),\n.epw-contact-page .epw-hero > .epw-wrap > p:not(.epw-eyebrow),\n.epw-disclaimer-page .epw-disclaimer-hero > .epw-wrap > p:not(.epw-eyebrow),\n.epw-coverage-page .epw-coverage-hero .epw-hero-grid > div:first-child > p:not(.epw-eyebrow),\n.epw-faq-page .epw-faq-hero-inner > p:not(.epw-eyebrow),\n.epw-about-page .epw-about-hero > .epw-wrap > p:not(.epw-eyebrow) {\n  color: rgba(255, 255, 255, 0.94) !important;\n}\n\n.epw-who-page .epw-hero .epw-eyebrow,\n.epw-serve-page .epw-hero .epw-eyebrow,\n.epw-coverage-page .epw-coverage-hero .epw-eyebrow,\n.epw-contact-page .epw-hero .epw-eyebrow,\n.epw-disclaimer-page .epw-disclaimer-hero .epw-eyebrow,\n.epw-faq-page .epw-faq-hero .epw-eyebrow,\n.epw-about-page .epw-about-hero .epw-eyebrow {\n  color: #ffffff !important;\n  opacity: 0.9;\n}\n\n.epw-coverage-page .epw-coverage-hero .epw-globe {\n  border-color: rgba(255, 255, 255, 0.38) !important;\n  background:\n    linear-gradient(90deg, transparent 49.5%, rgba(255, 255, 255, 0.20) 50%, transparent 50.5%),\n    linear-gradient(0deg, transparent 49.5%, rgba(255, 255, 255, 0.20) 50%, transparent 50.5%),\n    radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.07) 70%, rgba(255, 255, 255, 0.02) 100%) !important;\n  box-shadow: 0 12px 32px rgba(54, 0, 10, 0.20) !important;\n}\n.epw-coverage-page .epw-coverage-hero .epw-globe::before,\n.epw-coverage-page .epw-coverage-hero .epw-globe::after {\n  border-color: rgba(255, 255, 255, 0.20) !important;\n}\n.epw-coverage-page .epw-coverage-hero .epw-region-dot span {\n  color: #172033 !important;\n  background: rgba(255, 255, 255, 0.96) !important;\n  border-color: rgba(255, 255, 255, 0.95) !important;\n}\n\n.epw-who-page .epw-hero,\n.epw-serve-page .epw-hero,\n.epw-coverage-page .epw-coverage-hero,\n.epw-contact-page .epw-hero,\n.epw-disclaimer-page .epw-disclaimer-hero {\n  padding-top: 82px !important;\n  padding-bottom: 76px !important;\n}\n\n@media (max-width: 620px) {\n  .epw-who-page .epw-hero,\n  .epw-serve-page .epw-hero,\n  .epw-coverage-page .epw-coverage-hero,\n  .epw-contact-page .epw-hero,\n  .epw-disclaimer-page .epw-disclaimer-hero {\n    padding-top: 58px !important;\n    padding-bottom: 54px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
